import React from "react";

const Java_List = () => {
  return (
    <div>
      <h1>Java List</h1>
      <p>This page provides explanations, examples, and common use-cases for Java List in Java.</p>
    </div>
  );
};

export default Java_List;
